import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title="InvalidVaultedPaymentMethodIdException" mdxType="Item">
      <p>{`In case the id passed does not match any payment method previously retrieved by `}<a parentName="p" {...{
          "href": "./../vaultManagerFetchVaultedPaymentMethods"
        }}>{`fetchVaultedPaymentMethods`}</a>{`.`}</p>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      